// extracted by mini-css-extract-plugin
module.exports = {"dept-logo":"Header_dept-logo__2hqkO"};